module.exports = __webpack_public_path__ + "src/modules/home/training/images/1707.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1707.png
// module id = 790
// module chunks = 0